import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import MotivoParada from "model/meta/producao/MotivoParada";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import "react-hook-form";
import { useForm } from "react-hook-form";
import MotivoParadaService from "service/meta/producao/MotivoParadaService";

const motivoParadaService = new MotivoParadaService();

export default function MotivoParadaCadastro() {

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [motivoParada, setMotivoParada] = useState<MotivoParada>(new MotivoParada());
    const [titulo, setTitulo] = useState<string>('Motivo de parada');

    function validar() {

        if (!motivoParada.descricao) {
            setError("descricao", { type: "manual", message: "Descrição é Obrigatória" }, { shouldFocus: true })
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={motivoParada} service={motivoParadaService} setModel={(value: MotivoParada) => setMotivoParada(value)} validar={() => validar()} urlService="/motivoParada" pathCadastro="/motivoParada" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={motivoParada.controlaHorario}
                    onChange={(e) => { setMotivoParada({ ...motivoParada, controlaHorario: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Controla horário</label>
            </div>

            <div style={{ display: "flex" }}>
                <Checkbox
                    checked={motivoParada.desconsideraHorasNaMeta}
                    onChange={(e) => { setMotivoParada({ ...motivoParada, desconsideraHorasNaMeta: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Desconsidera horas paradas na meta</label>
            </div>

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Descrição</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.descricao ? "p-invalid" : ""}
                        required value={motivoParada.descricao}
                        style={{ width: '30%' }}
                        {...register("descricao", {
                            onChange: (e) => {
                                setMotivoParada({ ...motivoParada, descricao: e.target.value })
                                clearErrors("descricao")
                            }
                        })}
                    />
                </div>
                {errors.descricao && errors.descricao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.descricao?.message as string}</span> : null}
            </div>

        </BaseCadastro>
    )
}
